export const CHAT_CONSTANTS = {
  PAGINATION: {
    INITIAL_SIZE: 10,
    INITIAL_INDEX: 0,
  },
  TEXTAREA: {
    MAX_HEIGHT: 200,
  },
} as const;
